// extracted by mini-css-extract-plugin
module.exports = {"HeaderImage":"Payouts_HeaderImage__27Cwj","TextInput":"Payouts_TextInput__3vt9I","BankDetails":"Payouts_BankDetails__1Vw5l","error":"Payouts_error__1WUzm"};